// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { packageMetadata } from '../package-metadata';
import { validatePackage } from '@progress/kendo-vue-common';
/**
 * @hidden
 */

var InputSeparatorVue2 = {
  created: function created() {
    validatePackage(packageMetadata);
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    return h("span", {
      "class": 'k-input-separator'
    });
  }
};
/**
 * Represents the Kendo UI for Vue InputSeparator component. It can be used as a semarator
 *  between horizontal icons in prefi and suffic templates.
 *
 *  ```jsx
 *  <template>
 *    <InputSeparator>
 *  </template>
 *  ```
 */

var InputSeparator = InputSeparatorVue2;
export { InputSeparator, InputSeparatorVue2 };